<div class="compliance-container">
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<div class="row">
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/confidentiality.svg"
						alt=""
					/>
					<div class="challenges-list-head">Confidentiality</div>
					<div class="challenges-list-content">
						Get encryption at every layer. TLS in
						<br class="d-none d-xl-block" />
						transit, AES-256 for files, and
						<br class="d-none d-xl-block" />
						Transparent Data Encryption (TDE) at
						<br class="d-none d-xl-block" />
						rest for SQL Server.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/integrity.svg"
						alt=""
					/>
					<div class="challenges-list-head">Integrity</div>
					<div class="challenges-list-content">
						Prevent SQL injection via strongly typed APIs
						<br class="d-none d-xl-block" />
						and protect against outside alteration before
						<br class="d-none d-xl-block" />
						serving via hashed MD5 files.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/availability.svg"
						alt=""
					/>
					<div class="challenges-list-head">Availability</div>
					<div class="challenges-list-content">
						Provide real-time fail-over and non-disruptive
						<br class="d-none d-xl-block" />
						upgrades via Kubernetes and other
						<br class="d-none d-xl-block" />
						orchestration tools.
					</div>
				</div>
			</div>
			<a [routerLink]="['/pricing']">
				<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
					Get Started for Free
				</button></a
			>
		</div>
	</div>
</div>
